const educationInfo = [
  {
    id: 1,
    degree: 'B.Tech. in Computer Science',
    institution: 'The NorthCap University',
    location: 'Gurgaon, IN',
    year: 'May 2023',
    cgpa: '7.77',
  },
]

export default educationInfo
